import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Badge } from '@/components/ui';
import { getAdminAssistantThreads } from '@/data/client';

/* Every assistant conversation on this client, for Triton staff. Questions,
   answers, which data each answer drew on, and any handoff. */
export function AssistantTranscripts({ orgId }: { orgId: string }) {
  const { data, isLoading } = useQuery({ queryKey: ['admin', 'assistant', orgId], queryFn: () => getAdminAssistantThreads(orgId) });
  const [open, setOpen] = useState<string | null>(null);
  const threads = data?.threads ?? [];
  return (
    <div className="admin-form">
      <div className="admin-form__body">
        <section className="admin-sect">
          <h4 className="admin-sect__title">Ask tritonIQ conversations</h4>
          <p className="admin-hint">Everything this client's users have asked the assistant, newest first. Answers show the modules and windows they drew on; a handoff means the assistant declined to recommend an action and named the team instead.</p>
          {isLoading ? <p className="dash-muted">Loading…</p> : threads.length === 0 ? <p className="dash-muted">No conversations yet.</p> : (
            <div className="asst-admin">
              {threads.map((t) => (
                <div key={t.id} className="asst-admin__thread">
                  <button type="button" className="asst-admin__head" onClick={() => setOpen(open === t.id ? null : t.id)}>
                    <span className="asst-admin__title">{t.title || 'Conversation'}</span>
                    <span className="dash-muted">{t.userName || 'Unknown user'} · {t.updatedAt.slice(0, 16)} · {Math.floor(t.messageCount / 2)} Q</span>
                    {t.messages.some((m) => m.meta?.handoff) && <Badge variant="warning">handoff</Badge>}
                    {t.messages.some((m) => m.meta?.error) && <Badge variant="neutral">error</Badge>}
                  </button>
                  {open === t.id && (
                    <div className="asst-admin__msgs">
                      {t.messages.map((m) => (
                        <div key={m.id} className={`asst-admin__msg asst-admin__msg--${m.role}`}>
                          <div className="asst-admin__text">{m.text}</div>
                          {m.role === 'assistant' && m.meta && (
                            <div className="asst-admin__meta">
                              {m.meta.sources.length > 0 && <span>Sources: {m.meta.sources.join(' · ')}</span>}
                              {m.meta.chart && <span>Chart: {m.meta.chart.title}</span>}
                              {m.meta.handoff && <span>Handed to {m.meta.handoff.contact?.name ?? 'the team'} ({m.meta.handoff.topic})</span>}
                              {m.meta.error && <span className="admin-modal__err">Error: {m.meta.error}</span>}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
